import { StyleSheet, css } from 'aphrodite'

interface TextAreaProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  label?: string
  maxLength?: number
  rows?: number
}

export const TextArea: React.FC<TextAreaProps> = ({
  value,
  onChange,
  placeholder,
  label,
  maxLength,
  rows,
}) => {
  return (
    <div className={css(styles.fieldContainer)}>
      {label && <label className={css(styles.label)}>{label}</label>}
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={css(styles.TextArea)}
        maxLength={maxLength}
        rows={rows}
      />
    </div>
  )
}

const styles = StyleSheet.create({
  fieldContainer: {
    marginBottom: '16px',
    width: '100%',
  },
  label: {
    fontSize: '14px',
    color: '#374151',
    marginBottom: '4px',
    display: 'block',
    fontWeight: 500,
  },
  TextArea: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#F9FAFB',
    borderRadius: '6px',
    border: '1px solid #E5E7EB',
    fontSize: '14px',
    color: '#111827',
    minHeight: '120px',
    resize: 'vertical',
    ':focus': {
      outline: 'none',
      borderColor: '#2563EB',
      backgroundColor: '#FFFFFF',
    },
  },
})
